import Text from 'components/Text/Text';
import React, { useState, useEffect } from 'react';
import { IStyleSettings } from 'types';
import { rgbToHex, hexToRgb } from 'utils/helpers';
import classNames from 'classnames';
import style from './StyleInput.module.scss';

interface IStyleInput {
	setStyleSettings(styleItemId: string, value: string, key: string): void;
	data: IStyleSettings;
	countOfItems?: number;
	isDisabled: boolean;
}

const StyleInput: React.FC<IStyleInput> = ({ setStyleSettings, data, countOfItems = 0, isDisabled }) => {
	const [hexColor, setHexColor] = useState<string>(rgbToHex(data.value));
	const [rgbColor, setRgbColor] = useState<string>(data.value);
	const [isFirstChanges, setIsFirstChanges] = useState<boolean>(true);
	const containerClasses = classNames(style.container, {
		[style.defaultItem]: countOfItems === 0,
		[style.forOneItems]: countOfItems === 1,
		[style.forTwoItems]: countOfItems === 2,
		[style.forThreeItems]: countOfItems === 3,
		[style.forFourOrMoreItems]: countOfItems >= 4,
	});
	const colorAreaClasses = classNames(style.colorArea, { [style.cursorPointer]: !isDisabled });

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setHexColor(e.target.value);
		if (isFirstChanges) {
			setIsFirstChanges(false);
		}
	};

	useEffect(() => {
		const timeoutID = setTimeout(() => {
			const rgb = hexToRgb(hexColor);
			setRgbColor(`rgb(${rgb?.r},${rgb?.g},${rgb?.b})`);
		}, 800);
		return () => {
			return clearTimeout(timeoutID);
		};
	}, [hexColor]);

	useEffect(() => {
		if (!isFirstChanges) {
			setStyleSettings(data.id, rgbColor, data.key);
		}
	}, [rgbColor]);

	return (
		<div className={containerClasses} data-test={`ColorInput-${data.key}`}>
			<label className={style.colorLabel}>
				<div className={colorAreaClasses} style={{ background: `${hexColor}` }}></div>
				<input
					className={style.colorInput}
					onChange={handleChange}
					value={hexColor}
					disabled={isDisabled}
					type="color"
					name={data.id}
				/>
			</label>
			<div className={style.nameWrapper}>
				<Text
					translationNameSpace="mediaSettings"
					translationKey={data.key}
					size="s"
					weight="bold"
					withTooltip={true}
				/>
				<Text translationKey={rgbColor} theme="neutralLight" size="s" weight="bold" withTooltip={true} />
			</div>
		</div>
	);
};

export default React.memo(StyleInput);
